import { createSlice } from '@reduxjs/toolkit';

// Initialize from localStorage
const getInitialDashboardSection = () => {
  try {
    const saved = localStorage.getItem('lastActiveDashboardSection');
    return saved ? JSON.parse(saved) : 'calendar';
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return 'calendar';
  }
};

const initialState = {
  lastActiveDashboardSection: getInitialDashboardSection(),
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLastActiveDashboardSection: (state, action) => {
      state.lastActiveDashboardSection = action.payload;
      // Persist to localStorage immediately
      try {
        localStorage.setItem('lastActiveDashboardSection', JSON.stringify(action.payload));
      } catch (error) {
        console.error('Error saving to localStorage:', error);
      }
    },
  },
});

export const { setLastActiveDashboardSection } = uiSlice.actions;
export default uiSlice.reducer;
